module.exports = __webpack_public_path__ + "img/wechat.73fbb928.png";